<template>
	<c-dialog ref="dialog" width="100vw-300" mode="slide" mask-close @close="dialogFormEditConfirm($refs.workForm, arguments); beforeClose();" @resolve="editHandle" @cancel="beforeClose();">
		<template #head>
			<div v-if="editState" class="m-detail-tag flex-center-cross">
				<c-state dict="orderStateDic" tag :value="work_state"></c-state>
			</div>
		</template>
		
		<c-form ref="workForm" column="3" vertical unit-width="100%">
			<c-form link-parent>
				<c-form-item label="工单编号">
					<c-input name="work_code" placeholder="请输入，忽略将自动生成"></c-input>
					<c-input type="hidden" name="data_version_no" ></c-input>
				</c-form-item>
				<c-form-item label="计划时间" required>
					<c-datetime start-name="plan_start_date" end-name="plan_end_date" type="datetime" range v-model="plan_time" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
					<template #handle>
						<c-link v-if="auth('m_schedule_calendar')" icon="tf-calendar" @click="windowTo({name: 'm_schedule_calendar'})">排产日历</c-link>
					</template>
				</c-form-item>
				<c-form-item label="工单说明">
					<c-input type="textarea" name="remark"></c-input>
				</c-form-item>
				<c-form-item label="产品信息" required>
					<c-select name="product_id" v-model="product_id" async @search="searchProduct" :value-data="productOptions" @change="changeProduct" :clear="false"></c-select>
					<template #handle>
						<c-link v-if="auth('b_product_edit')" icon @click="globalDialog('productEdit')">创建产品</c-link>
					</template>
					<info-card code="PRODUCT" :id="product_id"></info-card>
				</c-form-item>
				<c-form-item label="计划数" required>
					<c-input type="stepper" name="plan_count" stepControls="side" v-model="plan_count" decimal="2" :range="[0.01,99999999]" :clear="false"></c-input>
					<info-card code="WORK" :id="work_id"></info-card>
				</c-form-item>

				<custom-form ref="customForm" work-type="3"></custom-form>
			</c-form>
			
			<c-title>生产任务</c-title>
			<c-form-item :label="false" name="task_list" colspan="3">
				<custom-table ref="taskTable" view-id="10002" work-type="9" drag :batch-edit="afterBatchEdit" @drag="updateProcessGroup">
					<template #operate>
						<c-button color="main" v-if="auth('b_work_create') || auth('b_work_edit')" v-lock="lock('b_work_create') || lock('b_work_edit')" prepend-icon="tf-add" @click="$refs.processSelector.open(9)">添加任务</c-button>
						<c-button color="red" v-if="auth('b_work_create') || auth('b_work_edit')" v-lock="lock('b_work_create') || lock('b_work_edit')" prepend-icon="tf-trash" hollow @click="batchRemoveTaskRow()">批量删除</c-button>
					</template>

					<template #otherOperate>
						<c-button v-if="auth('m_schedule_calendar')" v-lock="lock('m_schedule_calendar')" prepend-icon="tf-calendar" @click="windowTo({name: 'm_schedule_calendar', query: {task: true}})">排产日历</c-button>
					</template>
					
					<!--任务状态-->
					<template #state="{data}">
						<c-state dict="orderStateNoCancelDic" :value="data.state"></c-state>
					</template>
					
					<!--优先级-->
					<template #priority="{data}">
						<c-state dict="priorityDic" tag :value="data.priority"></c-state>
					</template>
					
					<!--报工数配比-->
					<template #output_ratio="{data}">
						<c-input name="output_ratio" type="number" decimal="6" :range="[0.000001,99999999]" v-model="data.output_ratio"  :clear="false" @change="changeCount('unit',data)"></c-input>
					</template>
					
					<!--加工类型-->
					<template #process_type="{data}">
						<c-select :options="processTypeDic" v-model="data.process_type" @change="processTypeHandle($event, data)" :clear="false">
							<template #option="{data, selected}">
								<select-option
									:name="data.name"
									:selected="selected"
									:vip="data.name != '自制'"
								></select-option>
							</template>
						</c-select>
					</template>
					<!--检验方式-->
					<template #test_mode="{data}">
						<c-select :options="testModeDic" v-model="data.test_mode" :disabled="data.process_type==2" @change="testModeHandle($event, data)" :clear="false">
							<template #option="{data, selected}">
								<select-option
									:name="data.name"
									:selected="selected"
									:vip="data.name != '免检'"
								></select-option>
							</template>
						</c-select>
					</template>
					
					<!--任务备注-->
					<template #remark="{data}">
						<c-input v-model="data.remark" type="textarea" :height-resize="{type: 'focus-auto', maxHeight: '140px'}"></c-input>
					</template>
					
					<template #production_sequence_tip="{data}">
						<c-tooltip tip="提示" width="360" align="end">
							<template #tip>
								<p>【在前工序之后】：必须在上一道工序报工完成后才能报工，数量受上道工序良品数限制</p>
								<p>【与前工序同时】：可与上一道工序同步报工，数量受非同步工序的良品数限制</p>
							</template>
						</c-tooltip>
					</template>
					<!--生产顺序-->
					<template #production_sequence="{data, index}">
						<div class="flex-center">
							<ins v-if="data.group" class="process-group-pre" :type="data.group"></ins>
							<c-select v-if="index" v-model="data.production_sequence" class="flex-grow" name="production_sequence" :options="productionSequenceDic" :clear="false" @change="updateProcessGroup"></c-select>
							<p v-else class="flex-grow">首道工序</p>
						</div>
					</template>
					
					<template #material_auto_out_tip="{data}">
						<c-tooltip tip="提示" width="360" align="end">
							<template #tip>
								<p>【自制】：当前工序报工后,对应工序需要用到的物料会自动出库,无需手动操作领料</p>
								<p>【外协】：当前工序对应的委外单发货时,对应外协工序需要用到的物料会自动出库,无需手动发料</p>
							</template>
						</c-tooltip>
					</template>
					<!--自动出库-->
					<template #material_auto_out="{data}">
						<c-check v-model="data.material_auto_out"></c-check>
					</template>
					
					<template #product_auto_in_tip="{data}">
						<c-tooltip tip="当前工序报工后,生产的成品会自动入库,无需手动再操作入库" ></c-tooltip>
					</template>
					<!--自动入库-->
					<template #product_auto_in="{data}">
						<c-check v-model="data.product_auto_in" :disabled="data.test_mode!=1"></c-check>
					</template>
					
					<template #output_start_tip="{data}">
						<c-tooltip tip="工人开始工作时手动打卡,只有存在开始工作打卡记录才允许报工" ></c-tooltip>
					</template>
					<!--报工前打卡-->
					<template #output_start="{data}">
						<c-check v-model="data.output_start" :disabled="data.process_type==2"></c-check>
					</template>
					
					<!--计划数-->
					<template #plan_count="{data}">
						<c-input name="plan_count" type="number" decimal="6" :range="[0.000001,99999999]" v-model="data.plan_count" :clear="false" @change="changeCount('count',data)"></c-input>
					</template>
					
					<!--不良品项列表-->
					<template #defects_names="{data}">
						<c-tags v-if="data.defects_names" :value="data.defects_names"></c-tags>
					</template>
					
					<!--计划开始时间-->
					<template #plan_start_date="{data}">
						<c-datetime name="plan_start_date" type="datetime" v-model="data.plan_start_date" time-accuracy="min" format="yyyy-MM-dd hh:mm"  :clear="false"></c-datetime>
					</template>
					
					<!--计划结束时间-->
					<template #plan_end_date="{data}">
						<c-datetime name="plan_end_date" type="datetime" v-model="data.plan_end_date" time-accuracy="min" format="yyyy-MM-dd hh:mm"  :clear="false"></c-datetime>
					</template>
					
					<!--报工权限 -->
					<template #output_auth_names="{data}">
						<span v-if="!data.output_auth_names" >-</span>
						<c-tags v-else :value="data.output_auth_names"></c-tags>
					</template>
					
					<!--最终报工权限(综合报工权限、分配报工权限，并考虑分配是否优先) -->
					<template #all_output_auth_names="{data}">
						<span v-if="!data.all_output_auth_names" >-</span>
						<c-tags v-else :value="data.all_output_auth_names"></c-tags>
					</template>
					
					<!--任务分配 -->
					<template #output_distribute_auth_names="{data}">
						<!-- <span v-if="!data.output_distribute_auth_names">-</span>
						<c-tags v-else="data.output_distribute_auth_names" :value="data.output_distribute_auth_names"></c-tags> -->
						<div class="flex-center">
							<div class="flex-grow">
								<c-tags v-if="data.output_distribute_auth_names" :value="data.output_distribute_auth_names"></c-tags>
							</div>
							<c-link v-if="auth('b_task_distribute') && (!data.work_state || data.work_state == 1 || data.work_state == 2)" color="main" style="margin-left: 10px; font-size: 20px;" @click="selectDistributeDig(data)"><i class="tf">&#xe691;</i></c-link>
						</div>
					</template>
					
					<!--任务进度%-->
					<template #task_progress="{data}">
						<c-progress v-if="data.id" :rate="[data.fine_count, data.plan_count]" :color="((data.fine_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
						<span v-else="data.id">-</span>
					</template>
					
					<c-table-column
                        type="button"
                        label="操作"
						width="60"
                    >
                        <template #default="{data,remove}">
							<c-table-button v-if="auth('b_work_create') || auth('b_work_edit')" v-lock="lock('b_work_create') || lock('b_work_edit')" icon="tf-trash" @click="removeTaskRow(data,remove); updateProcessGroup();">删除</c-table-button>
						</template>
					</c-table-column>
				</custom-table>
			</c-form-item>

			<c-title>用料清单</c-title>
			<c-form-item name="material_list" :label="false" colspan="3">
				<m-operate border>
					<c-button color="main" v-if="auth('b_work_create') || auth('b_work_edit')" v-lock="lock('b_work_create')" prepend-icon="tf-add" @click="globalDialog('productSelector', {props: {initParam: {product_types:[2, 3]}}}, productSelectorHandle)">添加用料</c-button>
					<c-button prepend-icon="tf-reload" color="main" v-if="auth('b_work_create') || auth('b_work_edit')" v-lock="lock('b_work_create')" @click="loadMaterialConfirm()" :disabled="!this.product_id">更新用料清单</c-button>
				</m-operate>
				<c-table ref="material_table" border :paging="false" width-resize>
					<c-table-column type="drag"></c-table-column>
					<c-table-column label="产品编号" width="100" name="product_code"></c-table-column>
					<c-table-column label="产品名称" width="200" name="product_name"></c-table-column>
					<c-table-column label="产品规格" width="150" name="product_spec"></c-table-column>
					<c-table-column label="单位" width="70" name="unit"></c-table-column>
					<c-table-column label="产品类型" width="70">
						<template #default="{data}">
							<c-state dict="productTypeName" :value="data.product_type"></c-state>
						</template>
					</c-table-column>
					<c-table-column label="产品来源" width="70">
						<template #default="{data}">
							<c-state dict="productSourceName" :value="data.product_source"></c-state>
						</template>
					</c-table-column>
					<c-table-column label="投料工序" width="200">
						<template #default="{data}">
							<c-select async @search="searchProcess" :value-data="data.childrenProcess" v-model="data.process_id"></c-select>
						</template>
					</c-table-column>
					<c-table-column label="单位用量" width="100">
						<template #default="{data}">
							<c-input type="number" decimal="6" :range="[0.000001,99999999]" v-model="data.unit_count" @change="changeMaterialCount('unit',data)"></c-input>
						</template>
					</c-table-column>
					<c-table-column label="预计用量" width="80" >
						<template #default="{data}">
							<c-input type="number" decimal="6" :range="[0.000001,99999999]" v-model="data.plan_count" @change="changeMaterialCount('count',data)"></c-input>
						</template>
					</c-table-column>
					<c-table-column label="当前库存" width="90">
						<template #default="{data, index}">
							<c-link v-if="data.product_count != 0" :ref="`stock${index}`" @click="stockHandle(data, index)">{{data.product_count}}</c-link>
							<span v-else>{{data.product_count}}</span>
						</template>
					</c-table-column>
					<c-table-column label="已领料数" width="70" name="picking_count"></c-table-column>
					<c-table-column label="已退料数" width="70" name="eject_count"></c-table-column>
					<c-table-column label="说明备注" width="130">
						<template #default="{data}">
							<c-input v-model="data.remark"></c-input>
						</template>
					</c-table-column>
					<c-table-column type="button" label="操作" width="60">
						<template #default="row">
							<c-table-button v-if="auth('b_work_create') || auth('b_work_edit')" v-lock="lock('b_work_create')" icon="tf-trash" @click="removeMaterialRow(row)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</c-form-item>
		</c-form>
		<!--选择工序弹窗-->
		<process-selector ref="processSelector" multiple @resolve="processSelectorHandle"></process-selector>
		
		<!--产品库存明细数据-->
		<c-window ref="stockWin" :title="stock_product_info+' - 库存明细'" align="start" height="160" width="220">
			<c-table ref="stockList" :paging="false">
				<c-table-column
					label="所属仓库"
					width="140"
					name="warehouse_name"
				>
					<template #default="{data}">
						<span v-if="data.product_count == 0" style="color:darkgrey;">{{data.warehouse_name}}</span>
						<span v-else>{{data.warehouse_name}}</span>
					</template>
				</c-table-column>
				<c-table-column
					label="库存"
					width="80"
					name="product_count"
				>
					<template #default="{data}">
						<span v-if="data.product_count == 0" style="color:darkgrey;">{{data.product_count}}</span>
						<span v-else>{{data.product_count}}</span>
					</template>
				</c-table-column>
			</c-table>
		</c-window>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
import processSelector from "@/components/service/process_selector.vue";

export default {
	name: 'b_work_edit',

	components: {
		processSelector
	},

	data() {
		return {
			editState: false,
			product_id:0,
			work_id:0,
			work_state: 1,
			plan_count:'',
			plan_time:[],
			productOptions:[],
			deleteTaskList:[],
			deleteMaterialList:[],
			selectTaskRow:{},
			stock_product_info:'',
			is_copy:false           //是否是复制页面
		}
	},
	
	computed: {
		...mapState(['systemConfig', 'productionSequenceDic', 'processTypeDic','testModeDic'])
	},
	
	// 监听器
	watch: {
		// 监听工单计划数
		plan_count(val, old) {
			this.$refs.taskTable.$refs.list.getRow().forEach(function (row, index) {
				row.update({
					plan_count: parseFloat((val*row.data.output_ratio).toFixed(2))   
				})
			});
			this.$refs.material_table.getRow().forEach(function (row, index) {
				row.update({
					plan_count: parseFloat((row.data.unit_count * val).toFixed(6))
				})
			});
		},
		//监听工单计划开始时间
		plan_time(val, old) {
			if(val){
				this.$refs.taskTable.$refs.list.getRow().forEach(function (row, index) {
					row.update({
						plan_start_date: val[0],
						plan_end_date: val[1]
					})
				});
			}
		},
	},
	
	methods: {
		/************打开新增、编辑弹窗**************/
		open(data, is_copy, opt) {
			this.is_copy = is_copy||false;
			this.editState = !this.is_copy && !!data;
			this.work_state = 1;
			
			this.deleteTaskList = [];
			this.deleteMaterialList =[];
			this.$refs.workForm.clear();
			//初始化自定义字段控件
			this.$refs.customForm.init();
			//初始化任务工序列表控件
			this.$refs.taskTable.init();
			//清空用料清单
			this.$refs.material_table.setData([]);
			this.product_id = '';
			if (data) {
				this.work_id = data.id;
				this.getDetail();
			}else {
				this.work_id = 0;
				if (opt && opt.planDate) {
					this.plan_time = opt.planDate;
				} else {
					this.plan_time = [new Date().format('yyyy-MM-dd 00:00'),new Date().format('yyyy-MM-dd 23:59')];
				}
			}
			this.$refs.dialog.open({
				title: data ? (this.is_copy ? '复制工单' : '编辑工单') : '创建工单'
			});
		},

		/*******搜索工单详情*******************/
		getDetail() {
			this.request({
				url:'/work/detail',
				data: {
					id: this.work_id
				},
				loading: true,
				success: data => {
					if (this.is_copy){
						this.work_id = 0;
						data.detailInfo.work_code = '';
					}
					this.work_state = data.detailInfo.work_state;
					//工单基本信息
					this.$refs.workForm.set(data.detailInfo);
					this.product_id = data.detailInfo.product_id;
					//处理选中商品信息
					this.productOptions = [{
						name: data.detailInfo.product_code +' | ' +data.detailInfo.product_name,
						value: data.detailInfo.product_id
					}];
					
					this.$nextTick(() => {
						//如果是复制模式，则将分配数据还原，可以携带导新的分配任务
						if(this.is_copy){
							data.taskList.map(item => {
								if(item.output_distribute_auth_ids && item.output_distribute_auth_ids.split(',').length > 0){
									item.distribute_list = [];
									item.output_distribute_auth_ids.split(',').forEach(distr => {
										item.distribute_list.push({
											user_id: distr, 
											user_realname: '', 
											qty: 0,
										});
									});
								}
								return item;
							});
						}
						//加载任务列表
						this.$refs.taskTable.$refs.list.setData(data.taskList);
						this.updateProcessGroup();
					
						//用料清单列表
						if (data.materialList && data.materialList.length > 0){
							var materialList = data.materialList.map(item => {
								var obj = item;
								if(item.process_id){
									obj.childrenProcess = [{
										name: item.process_name,
										value: item.process_id
									}];
								}
								return obj;
							});
							this.$refs.material_table.setData(materialList);
						}
					
					})
					
				}
			});
		},

		updateProcessGroup() {
			if (this.systemConfig.output_sort != '1') return;
			this.$nextTick(() => {
				let rows = this.$refs.taskTable.$refs.list.getRow();
				rows.forEach((row, index) => {
					let next = rows[index + 1];
					if (index == 0) {
						row.update({
							production_sequence: 1
						})
					}
					row.update({
						group: row.data.production_sequence == 1 && next && next.data.production_sequence == 2
							? 'first'
							: row.data.production_sequence == 2
								? next && next.data.production_sequence == 2 ? 'mid' : 'last'
								: ''
					});
				});
			});
		},

		/**加工类型变更事件*/
		processTypeHandle(selectData,rowData){
			if(selectData.value == 2){
				rowData.test_mode = 1;
				rowData.material_auto_out = 0;
				//rowData.product_auto_in = 0
			}
		},
		
		/**检验方式变更事件*/
		testModeHandle(selectData,rowData){
			if(selectData.value != 1){
				rowData.product_auto_in = 0;
			}
		},

		/*******搜索【产品】下拉框信息*****************/
		searchProduct(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'SELF_PRODUCT',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},
		
		/*******搜索【工序】下拉框信息*****************/
		searchProcess(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'DICPROCESS_SEARCH',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},
		
		/********变更产品下拉框数据*************/
		changeProduct({data}){
			this.product_id = data.id;
			
			if(!this.editState){
				//按产品工艺路线加载工序数据
				this.loadProcess(data.route_id);
			
				//按物料清单加载物料清单数据
				this.loadMaterial();
			}
			this.$refs.customForm.setDefaultData({
				work_type_id: 3,
				source_list: [[{
					ref_work_type_id: 7,
					ref_id: data.id
				}]]
			});
		},
		
		/**********按产品工艺路线加载工序数据*************/
		loadProcess(route_id){
			if(!route_id){
				return;
			}
			
			//记录清除空任务的ID
			this.$refs.taskTable.$refs.list.getData().forEach(item => {
				if(item.id && item.id > 0){
					this.deleteTaskList.push(item.id);
				}
			});
			//清空任务
			this.$refs.taskTable.$refs.list.setData([]);
			
			this.request({
				url:'/process/route/detail',
				data: {
					id: route_id
				},
				loading: {message:'正在加载工艺路线'},
				success: data => {
					if (data.process_list && data.process_list.length > 0){
						
						//处理数据
						var processList = data.process_list.map(item => {
							item.process_id = item.id;
							item.plan_count = this.plan_count*item.output_ratio;
							if(this.plan_time){
								item.plan_start_date = this.plan_time[0];
								item.plan_end_date = this.plan_time[1];
							}
							item.id = null;
							item.output_distribute_auth_names = null;
							//保留工艺路线带入的自定义字段值
							item.custom_fields_value_json = item.custom_fields_value_json || {};
							return item;
						});
						processList.map(item =>{
							this.$refs.taskTable.$refs.list.push(item);
						})
						this.updateProcessGroup();
					}else {
						this.$refs.taskTable.$refs.list.push([]);
					}
				}
			});
		},
		
		/**********按物料清单加载物料清单数据*************/
		loadMaterial(){
			if(!this.product_id){
				return;
			}
			//记录清除空物料清单的ID
			this.$refs.material_table.getData().forEach(item => {
				if(item.id && item.id > 0){
					this.deleteMaterialList.push(item.id);
				}
			});
			//清空物料清单
			this.$refs.material_table.setData([]);
			
			this.request({
				url:'/product/children/list',
				data: {
					product_id: this.product_id
				},
				loading: {message:'正在加载物料清单'},
				success: data => {
					//处理数据
					var materialList = data.map(item => {
						item.product_id = item.id;
						item.id = null;
						item.plan_count = parseFloat((this.plan_count*item.unit_count).toFixed(6));
						return item;
					});
					materialList.map(item =>{
						this.$refs.material_table.push(item);
					})
				}
			});
		},
		
		/******更新用料清单确认************/
		loadMaterialConfirm(){
			this.$confirm({
				title:'更新用料清单',
				message:'更新后当前用料清单信息将会被覆盖，请确认是否更新用料清单',  // 提示内容,
				// buttonName: '确定',  // 确定按钮文字
				cancelButton: true,  // 是否显示取消按钮
				resolve: () => {
					//获取已存在物料清单
					var material_list = this.$refs.material_table.getData();
					material_list.forEach(item => {
						if(item.id){
							//作为删除的物料清单
							this.deleteMaterialList.push(item.id);
						}
					});
					//重新加载物料清单
					this.loadMaterial();
				},  // 确定按钮回调
				cancel: () => {},  // 取消按钮回调
			});
		},
		
		/******批量删除任务行数据********/
		batchRemoveTaskRow() {
			//获取选中行
			const selectedRows = this.$refs.taskTable.$refs.list.getRow('selected');
			
			selectedRows.forEach(row => {
				const { id } = row.data;
				if (id && id > 0 && !this.deleteTaskList.includes(id)) {
					this.deleteTaskList.push(id);
				}
				// 本地移除行
				row.remove();
			});
		},

		/******删除任务行数据********/
		removeTaskRow(data, remove) {
			if (data.id && data.id > 0){
				this.deleteTaskList.push(data.id);
			}
			remove();
		},
		
		/******删除用料清单行数据********/
		removeMaterialRow(row) {
			var data = row.data;
			if(data.id && data.id > 0){
				this.deleteMaterialList.push(data.id);
			}
			row.remove();
		},

		/******选择工序响应方法*********/
		async processSelectorHandle(data) {
			this.$refs.taskTable.$refs.list.push(
				await this.$refs.taskTable.setDefaultData(data.map(item => {
					return Object.assign({}, item, {
						id: null,
						process_id: item.id,
						production_sequence: item.production_sequence||1,
						plan_count: this.plan_count * item.output_ratio,
						plan_start_date: this.plan_time ? this.plan_time[0] : '',
						plan_end_date: this.plan_time ? this.plan_time[1] : '',
						output_distribute_auth_names: null,
					});
				}))
			);
			this.updateProcessGroup();
		},
		
		/**任务计划数、配比变更后自动计算**/
		changeCount(type, data){
			if(this.plan_count){
				if (type=='unit') {
					data.plan_count = parseFloat((data.output_ratio * this.plan_count).toFixed(6));
				}else if (type=='count') {
					data.output_ratio = parseFloat((data.plan_count / this.plan_count).toFixed(6));
				}
			}
		},
		
		/**用料清单数、单位用量变更后自动计算**/
		changeMaterialCount(type, data){
			if(this.plan_count){
				if (type=='unit') {
					data.plan_count = parseFloat((data.unit_count * this.plan_count).toFixed(6));
				}else if (type=='count') {
					data.unit_count = parseFloat((data.plan_count / this.plan_count).toFixed(6));
				}
			}
		},
		
		/******选择产品用料响应方法*********/
		productSelectorHandle(data) {
			//处理数据
			var materialList = data.map(item => {
				item.product_id = item.id;
				item.unit_count = 1;
				item.plan_count = this.plan_count*item.unit_count;
				item.id = null;
				item.remark = '';
				return item;
			});
			materialList.map(item =>{
				this.$refs.material_table.push(item);
			})
		},
		
		//分配数据弹框
		selectDistributeDig(data){
			this.selectTaskRow = data;
			this.globalDialog('taskAllot', {
				props: {
					isStatic: true
				},
				data: data
			}, this.selectDistributeHandle);
		},
		
		//分配数据弹框回调
		selectDistributeHandle(distribute_list){
			let output_distribute_auth_names='';
			let i=0;
			distribute_list.forEach(item => {
				if(i==0){
					output_distribute_auth_names = item.user_realname;
				}else{
					output_distribute_auth_names += ','+item.user_realname;
				}
				i++;
			});
			this.selectTaskRow.output_distribute_auth_names = output_distribute_auth_names;
			this.selectTaskRow.distribute_list = distribute_list;
		},

		afterBatchEdit(field, value, rows) {
			switch (field.field_code) {
			case 'output_ratio':
				rows.forEach(({data}) => {
					this.changeCount('unit', data)
				});
				break;

			case 'plan_count':
				rows.forEach(({data}) => {
					this.changeCount('count', data)
				});
				break;

			case 'production_sequence':
				this.updateProcessGroup();
				break;
			}
		},
		
		stockHandle(data, index) {
			this.$refs.stockList.clear();
			this.stock_product_info = data.product_code;
		    //历史库存明细数据
			this.request({
				url: '/stock/product/detail/nopagelist',
				data: {
					product_id: data.product_id
				},
				success: detailList => {
					this.$refs.stockList.setData(detailList);
					this.$refs.stockWin.open(this.$refs[`stock${index}`]);
				}
			});
		},
		
		beforeClose() {
			if (this.$refs.stockWin) {
				this.$refs.stockWin.close();
			}
		},

		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			this.beforeClose();
			//任务列表
			var task_list = this.$refs.taskTable.$refs.list.getData();
			//用料清单列表
			var material_list = this.$refs.material_table.getData();
			
			this.$refs.workForm.submit({
				url: this.work_id==0?'/work/add':'/work/edit',
				rule: {
					product_id: '请选择产品',
					plan_start_date: '请选择计划开始时间',
					plan_end_date: '请选择计划结束时间',
					plan_count: '请输入工单计划数',
					task_list: data => {
						var flag = true;
						if(task_list.length == 0){
							let msg = "至少有一条工序任务";
							return msg;
						}
						task_list.forEach(item => {
							if(!item.output_ratio || !item.plan_count || !item.plan_start_date || !item.plan_end_date ){
								flag = false;
							}
						});
						if (!flag) {
							let msg = "请完善工序任务信息";
							return msg;
						}
						
						//自定义字段校验
						return this.$refs.taskTable.validate();
					},
					material_list: data => { 
						var flag = true;
						material_list.forEach(item => {
							if(!item.unit_count || !item.plan_count){
								flag = false;
							}
						});
						if(!flag){
							let msg = "请完善用料清单信息";
							return msg;
						}
						return flag||"请完善用料清单信息";
					},
					...this.$refs.customForm.rule
				},
			    dataFormatter: data => {
					data.id = this.work_id||0;
					//任务列表
					data.task_list = task_list.map(item => {
						return {
							id: item.id,
							process_id: item.process_id,
							plan_count: item.plan_count,
							plan_start_date: item.plan_start_date,
							plan_end_date: item.plan_end_date,
							output_ratio: item.output_ratio,
							remark: item.remark,
							material_auto_out: item.material_auto_out,
							product_auto_in: item.product_auto_in,
							process_type: item.process_type,
							test_mode: item.test_mode,
							output_start: item.output_start,
							production_sequence: item.production_sequence,
							distribute_list: item.distribute_list||null,
							custom_fields_value_json: JSON.stringify(item.custom_fields_value_json)
						}
					});
					//被删除的任务ID列表
					data.delete_task_list = this.deleteTaskList.map(item => {
						return {id:item}
					});
					
					//用料清单
					data.material_list = material_list.map(item => {
						return {
							id: item.id||0,
							process_id: item.process_id||0,
							product_id: item.product_id,
							unit_count: item.unit_count,
							plan_count: item.plan_count,
							remark: item.remark
						}
					});
					//被删除的用料清单ID列表
					data.delete_material_list = this.deleteMaterialList.map(item => {
						return {id:item}
					});
					
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						type: 'success',
						message:this.editState ? '编辑工单成功' : '创建工单成功',
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		}
	}
}
</script>